gsap.registerPlugin(ScrollTrigger);

{
    const home = document.querySelector(".home")

    gsap.to(".home .parallax", {
        y: "50%",
        scrollTrigger: {
            trigger: home,
            scrub: true,
            start: "0% 0%",
            end: "100% 0%"
        }
    });


    let bubble_text = [...home.querySelector(".bubble p").innerHTML]
    home.querySelector(".bubble p").innerHTML = ""

    bubble_text.map(letter => {
        let div = document.createElement("div");

        if (letter == " ") {
            div.innerHTML = "&nbsp"
        } else {
            div.innerHTML = letter
        }

        home.querySelector(".bubble p").appendChild(div)
    })


    let tlPulse_1 = gsap.timeline({
        repeat: -1,
        repeatDelay: 2
    });

    tlPulse_1.from(".home .pulse-1", {
        opacity: 0,
        x: 10,
        y: 10,
        duration: 0.5,
        ease: "linear"
    })
        .to(".home .pulse-1", {
            opacity: 0,
            x: -10,
            y: -10,
            duration: 0.5,
            ease: "linear",
        });


    let tlPulse_2 = gsap.timeline({
        repeat: -1,
        repeatDelay: 2
    });

    tlPulse_2.from(".home .pulse-2", {
        opacity: 0,
        x: -10,
        y: 10,
        duration: 0.5,
        ease: "linear"
    })
        .to(".home .pulse-2", {
            opacity: 0,
            x: 10,
            y: -10,
            duration: 0.5,
            ease: "linear",
        });


    let tlArrow = gsap.timeline({
        repeat: -1,
        repeatDelay: 2
    });

    tlArrow.to(".home .catchword svg", {
        x: -30,
        duration: 1,
        ease: "power1.out"
    })
        .to(".home .catchword svg", {
            x: 0,
            duration: 0.5,
            ease: "bounce.out"
        });

    let tl = gsap.timeline();

    tl.to(".home .dj", {
        clipPath: 'circle(80%)',
        y: 0,
        duration: 1
    }, 0)
        .from(".home .shape-purple", {
            xPercent: -80,
            yPercent: 100,
            duration: 1,
        }, 0.5)
        .from(".home .bubble svg", {
            scale: '0',
            rotate: '-15deg',
            x: 100,
            y: 100,
            duration: 0.5
        })
        .from(".home .bubble p div", {
            duration: 0.8,
            opacity: 0,
            y: 80,
            rotationX: 180,
            transformOrigin: "0% 50% -50",
            stagger: 0.01
        })
        .add(tlPulse_1, "<")
        .add(tlPulse_2, "<")
        .from(".home h1 span", {
            x: -50,
            opacity: 0,
            duration: 0.5,
            stagger: 0.2,
        }, 2)
        .from(".home .catchword svg", {
            scale: 0,
            x: -25,
            y: 25,
            rotate: '-90deg',
            duration: 0.5,
        })
        .add(tlArrow)
        .from(".home .catchword p", {
            opacity: 0,
            x: -50,
            duration: 0.5,
        }, "<")


}

{
    const schema = document.querySelector(".schema")

    gsap.to(".schema .curtain", {
        x: "100%",
        duration: 0.5,
        scrollTrigger: {
            trigger: ".schema .curtain",
            start: "100% 75%",
            end: "100% 25%"
        }
    });


    let label = [...document.querySelectorAll(".schema .label")]


    label.map(p => {

        // let p_text = [...p.innerHTML.replaceAll("<b>", "§").replaceAll("</b>", "§")]
        let p_word = p.innerHTML.replaceAll("<b>", "§").replaceAll("</b>", "§").split(/(\s+)/)
        p.innerHTML = ""

        let bold

        console.log();


        p_word.map(word => {

            let p_letter = [...word.replaceAll("<b>", "§").replaceAll("</b>", "§")]

            let wordDiv = document.createElement("div");
            wordDiv.classList.add("flex", "flex-wrap");
            p.appendChild(wordDiv)

            p_letter.map(letter => {

                if (letter == "§") {
                    bold = !bold
                } else {

                    let div
                    div = document.createElement("div");

                    if (letter == " ") {
                        div.innerHTML = "&nbsp"
                    } else {
                        div.innerHTML = letter
                    }

                    bold ? div.classList.add("font-extrabold") : "";
                    wordDiv.appendChild(div)
                }
            })



        })

        let tl = gsap.timeline({
            paused: true
        });

        tl.to(p.querySelectorAll("div > div"), {
            y: -10,
            duration: 0.2,
            stagger: 0.02,
        })
        tl.to(p.querySelectorAll("div > div"), {
            y: 0,
            duration: 0.2,
            stagger: 0.02,
        }, "<+=0.2")

        p.nextSibling.nextSibling.children[0].addEventListener("mouseover", () => {
            tl.play();
        })
        p.nextSibling.nextSibling.children[0].addEventListener("mouseout", () => {
            tl.reverse();
        })
    })

    let tl = gsap.timeline({
        scrollTrigger: {
            trigger: ".schema .marker",
            start: "top 50%",
            end: "bottom top",
            toggleActions: "play none none none"
        }
    });

    tl.from(".schema .pac", {
        y: "-125px",
        opacity: 0,
        duration: 0.5,
        ease: "power4.in"
    })
        .to(".schema .shine", {
            x: 0,
            y: 0,
            opacity: 1,
            duration: 0.5,
        })
        .from(".schema .bubble", {
            scale: 0,
            duration: 0.2,
            stagger: 0.1,
        })
        .to(".schema .branch", {
            strokeDashoffset: 0,
            duration: 0.3,
        })
        .to(".schema .label", {
            x: 0,
            opacity: 1,
            duration: 0.3,
        })

    // let h2_text = schema.querySelector("h2").innerHTML.replaceAll("<b>", "§").replaceAll("</b>", "§").split(/[^A-Za-z]/);
    // schema.querySelector("h2").innerHTML = ""

    // console.log(h2_text);

    // let bold = false

    // h2_text.map(letter => {



    //     if (letter == "§") {
    //         bold = !bold
    //     } else {

    //         let div
    //         div = document.createElement("div");

    //         if (letter == " ") {
    //             div.innerHTML = "&nbsp"
    //         } else {
    //             div.innerHTML = letter
    //         }

    //         bold ? div.classList.add("font-extrabold") : "";
    //         schema.querySelector("h2").appendChild(div)
    //     }

    // })
}

{
    const explanation = document.querySelector(".explanation")

    let tl = gsap.timeline({
        scrollTrigger: {
            trigger: explanation,
            start: "25% 75%",
            end: "bottom top",
            toggleActions: "play none none none"
        }
    });

    tl
        .from(".explanation h2", {
            opacity: 1,
            y: "-100%",
            duration: 0.5,
        })
        .from(".explanation .marker-p", {
            opacity: 1,
            y: "-100%",
            duration: 0.5,
        })
        .from(".explanation .marker-cols img", {
            scale: 0,
            duration: 1,
            ease: Elastic.easeOut,
        })
        .from(".explanation .marker-cols p", {
            y: "25px",
            opacity: 0,
            duration: 0.5,
        }, "<+=0.5")
        .from(".explanation .marker-cols svg", {
            opacity: 0,
            duration: 0.5,
        })

}

{
    const curve1Section = document.querySelector(".curve-pin-container")

    if ($(window).width() < 768) {
        new Flickity(curve1Section.querySelector('.carousel-mob'), {
            cellAlign: 'left',
            contain: true
        });
    } else {
        let sections = gsap.utils.toArray(curve1Section.querySelectorAll(".slide"));

        gsap.to(sections, {
            xPercent: -100 * (sections.length - 1),
            ease: "none",
            scrollTrigger: {
                trigger: curve1Section,
                scrub: 1,
                pin: true,
                start: "50% 50%",
                end: "+=150%"
            }
        });
    }
}

{
    const strengths = document.querySelector(".strengths")

    let tl = gsap.timeline({
        scrollTrigger: {
            trigger: strengths,
            start: "0% 50%",
            end: "bottom top",
            toggleActions: "play none none none"
        }
    });

    let tlShine = gsap.timeline({
        repeat: -1,
        repeatDelay: 2
    });

    tlShine.from(".strengths .marker-shine", {
        opacity: 0,
        x: -10,
        y: 10,
        duration: 0.5,
        ease: "linear"
    })
        .to(".strengths .marker-shine", {
            opacity: 0,
            x: 10,
            y: -10,
            duration: 0.5,
            ease: "linear",
        });

    tl.from(".strengths .marker-content", {
        opacity: 0,
    })
    .add(tlShine)


}

{
    const installation = document.querySelector(".installation")

    let link = installation.querySelector(".installation a ")
    console.log(link);

    link.addEventListener("mouseover", () => {
        tlH2.play();
    })
    link.addEventListener("mouseout", () => {
        tlH2.reverse();
    })


    let h2_text = [...installation.querySelector(".installation h2").innerHTML]
    installation.querySelector(".installation h2").innerHTML = ""

    h2_text.map(letter => {
        let div = document.createElement("div");

        if (letter == " ") {
            div.innerHTML = "&nbsp"
        } else {
            div.innerHTML = letter
        }

        installation.querySelector(".installation h2").appendChild(div)
    })

    let tlH2 = gsap.timeline({
        paused: true
    });

    tlH2.to(".installation h2 div", {
        y: -20,
        duration: 0.2,
        stagger: 0.02,
    })

}


{
    const curve1Section = document.querySelector(".postit-pin-container")

    if ($(window).width() < 768) {
        new Flickity(curve1Section.querySelector('.carousel-mob'), {
            cellAlign: 'left',
            contain: true
        });
    } else {
        let sections = gsap.utils.toArray(curve1Section.querySelectorAll(".slide"));

        gsap.to(sections, {
            xPercent: -100 * (sections.length - 1),
            ease: "none",
            scrollTrigger: {
                trigger: curve1Section,
                scrub: 1,
                pin: true,
                start: "50% 50%",
                end: "+=100%"
            }
        });
    }
}

{
    const aid = document.querySelector(".aid")

    let tlText = gsap.timeline({
        scrollTrigger: {
            trigger: ".aid .marker-content",
            start: "25% 75%",
            end: "bottom top",
            toggleActions: "play none none none"
        }
    });



    tlText.from(".aid .marker-content img", {
        opacity: 0,
        y: 50,
        duration: 0.5,
    })
        .from(".aid .marker-content h3", {
            opacity: 0,
            y: -50,
            duration: 0.5,
        })

        .from(".aid .marker-content p", {
            opacity: 0,
            y: -50,
            duration: 0.5,
        })


    let tlTable1 = gsap.timeline({
        scrollTrigger: {
            trigger: ".aid .marker-table1",
            start: "0% 75%",
            end: "bottom top",
        }
    });


    tlTable1.from(".aid .marker-h3", {
        opacity: 0,
        y: -50,
        duration: 0.5,
    })
        .from(".aid .marker-table1", {
            opacity: 0,
            duration: 0.5,
        })
        .from(".aid .marker-table2", {
            opacity: 0,
            duration: 0.5,
        },0.5)
}

{
    const offer = document.querySelector(".offer")

    let startPixel
    let endPixel

    if (window.matchMedia('(max-width: 767px)').matches) {
        startPixel = "-25% 50%"
        endPixel = "25% 50%"
    } else {
        startPixel = "0% 75%"
        endPixel = "75% 75%"
    }



    gsap.to(".offer .curtain", {
        x: "100%",
        scrollTrigger: {
            trigger: offer,
            scrub: 1,
            start: startPixel,
            end: endPixel,
            onLeave: () => {
                tl.play();
            },
        }
    });

    let tl = gsap.timeline({
        paused: true
    });

    tl.from(".offer .shine1", {
        x: 20,
        y: 20,
        opacity: 0,
        duration: 0.5,
    }, 0.35)
    .from(".offer .shine2", {
        x: -20,
        y: 20,
        opacity: 0,
        duration: 0.5,
    }, 0.35)
    .from(".offer .shine3", {
        x: 20,
        y: -20,
        opacity: 0,
        duration: 0.5,
    }, 0.35)
    .from(".offer .shine4", {
        x: -20,
        y: -20,
        opacity: 0,
        duration: 0.5,
    }, 0.35)
    // from(".offer h2", {
    //     scale: 0,
    //     opacity: 0,
    //     duration: 1,
    //     ease: "Bounce.easeOut"
    // })

        // .from(".offer .marker-content p", {
        //     opacity: 0,
        //     y: -50,
        //     duration: 0.5,
        // })
        // .from(".offer .marker-content a", {
        //     opacity: 0,
        //     y: -50,
        //     duration: 0.5,
        // })

}

{
    const articles = document.querySelectorAll(".articleLink")

    let tl;
    for(let i = 1; i <= articles.length; i++ ){
        const articleSelector = ".articleLink"+i;

        tl = gsap.timeline({
            scrollTrigger: {
                trigger: articleSelector,
                start: "25% 75%",
                end: "bottom top",
                toggleActions: "play none none none"
            }
        });

        tl.from(`${articleSelector} img`, {
            opacity: 0,
            y: 50,
            duration: 0.5,
        })
            .from(`${articleSelector} h2`, {
                opacity: 0,
                y: -50,
                duration: 0.5,
            }, 0)

            .from(`${articleSelector} p`, {
                opacity: 0,
                y: -50,
                duration: 0.5,
            }, 0)
            .from(`${articleSelector} a`, {
                opacity: 0,
                y: -50,
                duration: 0.5,
            }, 0)
    }
}

{
    let cta = [...document.querySelectorAll(".cta span")]


    cta.map(btn => {

        let btn_text = [...btn.innerHTML]
        btn.innerHTML = ""


        btn_text.map(letter => {
            let div = document.createElement("div");

            if (letter == " ") {
                div.innerHTML = "&nbsp"
            } else {
                div.innerHTML = letter
            }

            btn.appendChild(div)
        })

        let tl = gsap.timeline({
            paused: true
        });

        tl.to(btn.querySelectorAll("div"), {
            y: -10,
            duration: 0.2,
            stagger: 0.02,
        })
        tl.to(btn.querySelectorAll("div"), {
            y: 0,
            duration: 0.2,
            stagger: 0.02,
        }, "<+=0.2")

        btn.parentNode.addEventListener("mouseover", () => {
            tl.play();
        })
        btn.parentNode.addEventListener("mouseout", () => {
            tl.reverse();
        })
    })





    // let h2_text = [...installation.querySelector(".installation h2").innerHTML]
    // installation.querySelector(".installation h2").innerHTML = ""

    // h2_text.map(letter => {
    //     let div = document.createElement("div");

    //     if (letter == " ") {
    //         div.innerHTML = "&nbsp"
    //     } else {
    //         div.innerHTML = letter
    //     }

    //     installation.querySelector(".installation h2").appendChild(div)
    // })

}